// SIAP Lookup - Import Single Fixture, User, or Club

document.addEventListener('DOMContentLoaded', function() {
  // Helper function to handle import
  function setupImportButton(btnId, statusId, endpoint, datasetKey, paramKey) {
    const importBtn = document.getElementById(btnId);
    if (!importBtn) return;

    importBtn.addEventListener('click', function() {
      const code = this.dataset[datasetKey];
      const isUpdate = this.dataset.isUpdate === 'true';
      const statusEl = document.getElementById(statusId);

      // Disable button and show loading
      importBtn.disabled = true;
      importBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Processing...';
      statusEl.innerHTML = '';

      // Make AJAX request
      const body = {};
      body[paramKey] = code;

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify(body)
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Show success message
          statusEl.innerHTML = `
            <span class="badge badge-success">
              <i class="fas fa-check-circle"></i> ${data.message}
            </span>
          `;

          // Update button text
          importBtn.disabled = false;
          importBtn.dataset.isUpdate = 'true';
          importBtn.innerHTML = '<i class="fas fa-sync-alt"></i> Update';

        } else {
          // Show error message
          statusEl.innerHTML = `
            <span class="badge badge-danger">
              <i class="fas fa-exclamation-circle"></i> ${data.error || data.message}
            </span>
          `;

          // Re-enable button
          importBtn.disabled = false;
          const icon = isUpdate ? 'fa-sync-alt' : 'fa-download';
          const text = isUpdate ? 'Update' : 'Import';
          importBtn.innerHTML = `<i class="fas ${icon}"></i> ${text}`;
        }
      })
      .catch(error => {
        console.error('Error:', error);
        statusEl.innerHTML = `
          <span class="badge badge-danger">
            <i class="fas fa-exclamation-circle"></i> An error occurred
          </span>
        `;

        // Re-enable button
        importBtn.disabled = false;
        const icon = isUpdate ? 'fa-sync-alt' : 'fa-download';
        const text = isUpdate ? 'Update' : 'Import';
        importBtn.innerHTML = `<i class="fas ${icon}"></i> ${text}`;
      });
    });
  }

  // Setup import buttons for each entity type
  // setupImportButton(btnId, statusId, endpoint, datasetKey, paramKey)
  setupImportButton('import-fixture-btn', 'import-status', '/admin/siap_integrations/import_single_fixture', 'fixtureCode', 'fixture_code');
  setupImportButton('import-user-btn', 'import-user-status', '/admin/siap_integrations/import_single_user', 'userCode', 'user_code');
  setupImportButton('import-club-btn', 'import-club-status', '/admin/siap_integrations/import_single_club', 'clubCode', 'club_code');
});
